export default [
  {svgNum:'001',wx:'晴天'},
  {svgNum:'002',wx:'晴時多雲'},
  {svgNum:'003',wx:'多雲時晴'},
  {svgNum:'004',wx:'多雲'},
  {svgNum:'005',wx:'多雲時陰'},
  {svgNum:'006',wx:'陰時多雲'},
  {svgNum:'007',wx:'陰天'},
  {svgNum:'008',wx:'多雲陣雨'},
  {svgNum:'008',wx:'多雲短暫雨'},
  {svgNum:'008',wx:'多雲短暫陣雨'},
  {svgNum:'008',wx:'午後短暫陣雨 '},
  {svgNum:'008',wx:'短暫陣雨'},
  {svgNum:'008',wx:'多雲時晴短暫陣雨'},
  {svgNum:'008',wx:'多雲時晴短暫雨'},
  {svgNum:'008',wx:'晴時多雲短暫陣雨'},
  {svgNum:'008',wx:'晴短暫陣雨'},
  {svgNum:'009',wx:'多雲時陰短暫雨'},
  {svgNum:'009',wx:'多雲時陰短暫陣雨'},
  {svgNum:'010',wx:'陰時多雲短暫雨'},
  {svgNum:'010',wx:'陰時多雲短暫陣雨'},
  {svgNum:'011',wx:'雨天'},
  {svgNum:'011',wx:'晴午後陰短暫雨'},
  {svgNum:'011',wx:'晴午後陰短暫陣雨或雷雨'},
  {svgNum:'011',wx:'陰短暫雨'},
  {svgNum:'011',wx:'陰短暫陣雨'},
  {svgNum:'011',wx:'陰午後短暫陣雨'},
  {svgNum:'012',wx:'多雲時陰有雨'},
  {svgNum:'012',wx:'多雲時陰陣雨'},
  {svgNum:'012',wx:'晴時多雲陣雨'},
  {svgNum:'012',wx:'多雲時晴陣雨'},
  {svgNum:'013',wx:'陰時多雲有雨'},
  {svgNum:'013',wx:'陰時多雲有陣雨'},
  {svgNum:'013',wx:'陰時多雲陣雨'},
  {svgNum:'014',wx:'陰有雨'},
  {svgNum:'014',wx:'陰有陣雨'},
  {svgNum:'014',wx:'陰雨'},
  {svgNum:'014',wx:'陰陣雨'},
  {svgNum:'014',wx:'陣雨'},
  {svgNum:'014',wx:'午後陣雨'},
  {svgNum:'014',wx:'有雨'},
  {svgNum:'015',wx:'多雲陣雨或雷雨'},
  {svgNum:'015',wx:'多雲短暫陣雨或雷雨'},
  {svgNum:'015',wx:'多雲短暫雷陣雨'},
  {svgNum:'015',wx:'多雲雷陣雨'},
  {svgNum:'015',wx:'短暫陣雨或雷雨後多雲'},
  {svgNum:'015',wx:'短暫雷陣雨後多雲'},
  {svgNum:'015',wx:'短暫陣雨或雷雨'},
  {svgNum:'015',wx:'晴時多雲短暫陣雨或雷雨'},
  {svgNum:'015',wx:'晴短暫陣雨或雷雨'},
  {svgNum:'015',wx:'多雲時晴短暫陣雨或雷雨'},
  {svgNum:'015',wx:'午後短暫雷陣雨'},
  {svgNum:'016',wx:'多雲時陰陣雨或雷雨'},
  {svgNum:'016',wx:'多雲時陰短暫陣雨或雷雨'},
  {svgNum:'016',wx:'多雲時陰短暫雷陣雨'},
  {svgNum:'016',wx:'多雲時陰雷陣雨'},
  {svgNum:'016',wx:'晴陣雨或雷雨'},
  {svgNum:'016',wx:'晴時多雲陣雨或雷雨'},
  {svgNum:'016',wx:'多雲時晴陣雨或雷雨'},
  {svgNum:'017',wx:'陰時多雲有雷陣雨'},
  {svgNum:'017',wx:'陰時多雲陣雨或雷雨'},
  {svgNum:'017',wx:'陰時多雲短暫陣雨或雷雨'},
  {svgNum:'017',wx:'陰時多雲短暫雷陣雨'},
  {svgNum:'017',wx:'陰時多雲雷陣雨'},
  {svgNum:'018',wx:'陰有陣雨或雷雨'},
  {svgNum:'018',wx:'陰有雷陣雨'},
  {svgNum:'018',wx:'陰陣雨或雷雨'},
  {svgNum:'018',wx:'陰雷陣雨'},
  {svgNum:'018',wx:'晴午後陰短暫陣雨或雷雨'},
  {svgNum:'018',wx:'晴午後陰短暫雷陣雨'},
  {svgNum:'018',wx:'陰短暫陣雨或雷雨'},
  {svgNum:'018',wx:'陰短暫雷陣雨'},
  {svgNum:'018',wx:'雷雨'},
  {svgNum:'018',wx:'陣雨或雷雨後多雲'},
  {svgNum:'018',wx:'陰陣雨或雷雨後多雲'},
  {svgNum:'018',wx:'陰短暫陣雨或雷雨後多雲'},
  {svgNum:'018',wx:'陰短暫雷陣雨後多雲'},
  {svgNum:'018',wx:'陰雷陣雨後多雲'},
  {svgNum:'018',wx:'雷陣雨後多雲'},
  {svgNum:'018',wx:'陣雨或雷雨'},
  {svgNum:'018',wx:'雷陣雨'},
  {svgNum:'018',wx:'午後雷陣雨'},
  {svgNum:'019',wx:'晴午後多雲局部雨'},
  {svgNum:'019',wx:'晴午後多雲局部陣雨'},
  {svgNum:'019',wx:'晴午後多雲局部短暫雨'},
  {svgNum:'019',wx:'晴午後多雲局部短暫陣雨'},
  {svgNum:'019',wx:'晴午後多雲短暫雨'},
  {svgNum:'019',wx:'晴午後多雲短暫陣雨'},
  {svgNum:'019',wx:'晴午後局部雨'},
  {svgNum:'019',wx:'晴午後局部陣雨'},
  {svgNum:'019',wx:'晴午後局部短暫雨'},
  {svgNum:'019',wx:'晴午後局部短暫陣雨'},
  {svgNum:'019',wx:'晴午後局部短暫陣雨'},
  {svgNum:'019',wx:'晴午後短暫雨'},
  {svgNum:'019',wx:'晴午後短暫陣雨'},
  {svgNum:'019',wx:'晴時多雲午後短暫陣雨'},
  {svgNum:'020',wx:'多雲午後局部雨'},
  {svgNum:'020',wx:'多雲午後局部陣雨'},
  {svgNum:'020',wx:'多雲午後局部短暫雨'},
  {svgNum:'020',wx:'多雲午後局部短暫陣雨'},
  {svgNum:'020',wx:'多雲午後陣雨'},
  {svgNum:'020',wx:'多雲午後短暫雨'},
  {svgNum:'020',wx:'多雲午後短暫陣雨'},
  {svgNum:'020',wx:'多雲時陰午後短暫陣雨'},
  {svgNum:'020',wx:'陰時多雲午後短暫陣雨'},
  {svgNum:'020',wx:'多雲時晴午後短暫陣雨'},
  {svgNum:'021',wx:'晴午後多雲陣雨或雷雨'},
  {svgNum:'021',wx:'晴午後多雲雷陣雨'},
  {svgNum:'021',wx:'晴午後陣雨或雷雨'},
  {svgNum:'021',wx:'晴午後雷陣雨'},
  {svgNum:'021',wx:'晴午後多雲局部陣雨或雷雨'},
  {svgNum:'021',wx:'晴午後多雲局部短暫陣雨或雷雨'},
  {svgNum:'021',wx:'晴午後多雲局部短暫雷陣雨'},
  {svgNum:'021',wx:'晴午後多雲局部雷陣雨'},
  {svgNum:'021',wx:'晴午後多雲短暫陣雨或雷雨'},
  {svgNum:'021',wx:'晴午後多雲短暫雷陣雨'},
  {svgNum:'021',wx:'晴午後局部短暫雷陣雨'},
  {svgNum:'021',wx:'晴午後局部雷陣雨'},
  {svgNum:'021',wx:'晴午後短暫雷陣雨'},
  {svgNum:'021',wx:'晴雷陣雨'},
  {svgNum:'021',wx:'晴時多雲雷陣雨'},
  {svgNum:'021',wx:'晴時多雲午後短暫雷陣雨'},
  {svgNum:'022',wx:'多雲午後局部陣雨或雷雨'},
  {svgNum:'022',wx:'多雲午後局部短暫陣雨或雷雨'},
  {svgNum:'022',wx:'多雲午後局部短暫雷陣雨'},
  {svgNum:'022',wx:'多雲午後局部雷陣雨'},
  {svgNum:'022',wx:'多雲午後陣雨或雷雨'},
  {svgNum:'022',wx:'多雲午後短暫陣雨或雷雨'},
  {svgNum:'022',wx:'多雲午後短暫雷陣雨'},
  {svgNum:'022',wx:'多雲午後雷陣雨'},
  {svgNum:'022',wx:'多雲時晴雷陣雨'},
  {svgNum:'022',wx:'多雲時晴午後短暫雷陣雨'},
  {svgNum:'022',wx:'多雲時陰午後短暫雷陣雨'},
  {svgNum:'022',wx:'陰時多雲午後短暫雷陣雨'},
  {svgNum:'022',wx:'陰午後短暫雷陣雨'},
  {svgNum:'023',wx:'多雲局部陣雨或雪'},
  {svgNum:'023',wx:'多雲時陰有雨或雪'},
  {svgNum:'023',wx:'多雲時陰短暫雨或雪'},
  {svgNum:'023',wx:'多雲短暫雨或雪'},
  {svgNum:'023',wx:'陰有雨或雪'},
  {svgNum:'023',wx:'陰時多雲有雨或雪'},
  {svgNum:'023',wx:'陰時多雲短暫雨或雪'},
  {svgNum:'023',wx:'陰短暫雨或雪'},
  {svgNum:'023',wx:'多雲時陰有雪'},
  {svgNum:'023',wx:'多雲時陰短暫雪'},
  {svgNum:'023',wx:'多雲短暫雪'},
  {svgNum:'023',wx:'陰有雪'},
  {svgNum:'023',wx:'陰時多雲有雪'},
  {svgNum:'023',wx:'陰時多雲短暫雪'},
  {svgNum:'023',wx:'陰短暫雪'},
  {svgNum:'023',wx:'有雨或雪'},
  {svgNum:'023',wx:'有雨或短暫雪'},
  {svgNum:'023',wx:'陰有雨或短暫雪'},
  {svgNum:'023',wx:'陰時多雲有雨或短暫雪'},
  {svgNum:'023',wx:'多雲時陰有雨或短暫雪'},
  {svgNum:'023',wx:'多雲有雨或短暫雪'},
  {svgNum:'023',wx:'多雲有雨或雪'},
  {svgNum:'023',wx:'多雲時晴有雨或雪'},
  {svgNum:'023',wx:'晴時多雲有雨或雪'},
  {svgNum:'023',wx:'晴有雨或雪'},
  {svgNum:'023',wx:'短暫雨或雪'},
  {svgNum:'023',wx:'多雲時晴短暫雨或雪'},
  {svgNum:'023',wx:'晴時多雲短暫雨或雪'},
  {svgNum:'023',wx:'晴短暫雨或雪'},
  {svgNum:'023',wx:'有雪'},
  {svgNum:'023',wx:'多雲有雪'},
  {svgNum:'023',wx:'多雲時晴有雪'},
  {svgNum:'023',wx:'晴時多雲有雪'},
  {svgNum:'023',wx:'晴有雪'},
  {svgNum:'023',wx:'短暫雪'},
  {svgNum:'023',wx:'多雲時晴短暫雪'},
  {svgNum:'023',wx:'晴時多雲短暫雪'},
  {svgNum:'023',wx:'晴短暫雪'},
  {svgNum:'024',wx:'晴有霧'},
  {svgNum:'024',wx:'晴晨霧'},
  {svgNum:'025',wx:'晴時多雲有霧'},
  {svgNum:'025',wx:'晴時多雲晨霧'},
  {svgNum:'026',wx:'多雲時晴有霧'},
  {svgNum:'026',wx:'多雲時晴晨霧'},
  {svgNum:'027',wx:'多雲有霧'},
  {svgNum:'027',wx:'多雲晨霧'},
  {svgNum:'027',wx:'有霧'},
  {svgNum:'027',wx:'晨霧'},
  {svgNum:'028',wx:'陰有霧'},
  {svgNum:'028',wx:'陰晨霧'},
  {svgNum:'028',wx:'多雲時陰有霧'},
  {svgNum:'028',wx:'多雲時陰晨霧'},
  {svgNum:'028',wx:'陰時多雲有霧'},
  {svgNum:'028',wx:'陰時多雲晨霧'},
  {svgNum:'029',wx:'多雲局部雨'},
  {svgNum:'029',wx:'多雲局部陣雨'},
  {svgNum:'029',wx:'多雲局部短暫雨'},
  {svgNum:'029',wx:'多雲局部短暫陣雨'},
  {svgNum:'030',wx:'多雲時陰局部雨'},
  {svgNum:'030',wx:'多雲時陰局部陣雨'},
  {svgNum:'030',wx:'多雲時陰局部短暫雨'},
  {svgNum:'030',wx:'多雲時陰局部短暫陣雨'},
  {svgNum:'030',wx:'晴午後陰局部雨'},
  {svgNum:'030',wx:'晴午後陰局部陣雨'},
  {svgNum:'030',wx:'晴午後陰局部短暫雨'},
  {svgNum:'030',wx:'晴午後陰局部短暫陣雨'},
  {svgNum:'030',wx:'陰局部雨'},
  {svgNum:'030',wx:'陰局部陣雨'},
  {svgNum:'030',wx:'陰局部短暫雨'},
  {svgNum:'030',wx:'陰局部短暫陣雨'},
  {svgNum:'030',wx:'陰時多雲局部雨'},
  {svgNum:'030',wx:'陰時多雲局部陣雨'},
  {svgNum:'030',wx:'陰時多雲局部短暫雨'},
  {svgNum:'030',wx:'陰時多雲局部短暫陣雨'},
  {svgNum:'031',wx:'多雲有霧有局部雨'},
  {svgNum:'031',wx:'多雲有霧有局部陣雨'},
  {svgNum:'031',wx:'多雲有霧有局部短暫雨'},
  {svgNum:'031',wx:'多雲有霧有局部短暫陣雨'},
  {svgNum:'031',wx:'多雲有霧有陣雨'},
  {svgNum:'031',wx:'多雲有霧有短暫雨'},
  {svgNum:'031',wx:'多雲有霧有短暫陣雨'},
  {svgNum:'031',wx:'多雲局部雨有霧'},
  {svgNum:'031',wx:'多雲局部雨晨霧'},
  {svgNum:'031',wx:'多雲局部陣雨有霧'},
  {svgNum:'031',wx:'多雲局部陣雨晨霧'},
  {svgNum:'031',wx:'多雲局部短暫雨有霧'},
  {svgNum:'031',wx:'多雲局部短暫雨晨霧'},
  {svgNum:'031',wx:'多雲局部短暫陣雨有霧'},
  {svgNum:'031',wx:'多雲局部短暫陣雨晨霧'},
  {svgNum:'031',wx:'多雲陣雨有霧'},
  {svgNum:'031',wx:'多雲短暫雨有霧'},
  {svgNum:'031',wx:'多雲短暫雨晨霧'},
  {svgNum:'031',wx:'多雲短暫陣雨有霧'},
  {svgNum:'031',wx:'多雲短暫陣雨晨霧'},
  {svgNum:'031',wx:'有霧有短暫雨'},
  {svgNum:'031',wx:'有霧有短暫陣雨'},
  {svgNum:'032',wx:'多雲時陰有霧有局部雨'},
  {svgNum:'032',wx:'多雲時陰有霧有局部陣雨'},
  {svgNum:'032',wx:'多雲時陰有霧有局部短暫雨'},
  {svgNum:'032',wx:'多雲時陰有霧有局部短暫陣雨'},
  {svgNum:'032',wx:'多雲時陰有霧有陣雨'},
  {svgNum:'032',wx:'多雲時陰有霧有短暫雨'},
  {svgNum:'032',wx:'多雲時陰有霧有短暫陣雨'},
  {svgNum:'032',wx:'多雲時陰局部雨有霧'},
  {svgNum:'032',wx:'多雲時陰局部陣雨有霧'},
  {svgNum:'032',wx:'多雲時陰局部短暫雨有霧'},
  {svgNum:'032',wx:'多雲時陰局部短暫陣雨有霧'},
  {svgNum:'032',wx:'多雲時陰陣雨有霧'},
  {svgNum:'032',wx:'多雲時陰短暫雨有霧'},
  {svgNum:'032',wx:'多雲時陰短暫雨晨霧'},
  {svgNum:'032',wx:'多雲時陰短暫陣雨有霧'},
  {svgNum:'032',wx:'多雲時陰短暫陣雨晨霧'},
  {svgNum:'032',wx:'陰有霧有陣雨'},
  {svgNum:'032',wx:'陰局部雨有霧'},
  {svgNum:'032',wx:'陰局部陣雨有霧'},
  {svgNum:'032',wx:'陰局部短暫陣雨有霧'},
  {svgNum:'032',wx:'陰時多雲有霧有局部雨'},
  {svgNum:'032',wx:'陰時多雲有霧有局部陣雨'},
  {svgNum:'032',wx:'陰時多雲有霧有局部短暫雨'},
  {svgNum:'032',wx:'陰時多雲有霧有局部短暫陣雨'},
  {svgNum:'032',wx:'陰時多雲有霧有陣雨'},
  {svgNum:'032',wx:'陰時多雲有霧有短暫雨'},
  {svgNum:'032',wx:'陰時多雲有霧有短暫陣雨'},
  {svgNum:'032',wx:'陰時多雲局部雨有霧'},
  {svgNum:'032',wx:'陰時多雲局部陣雨有霧'},
  {svgNum:'032',wx:'陰時多雲局部短暫雨有霧'},
  {svgNum:'032',wx:'陰時多雲局部短暫陣雨有霧'},
  {svgNum:'032',wx:'陰時多雲陣雨有霧'},
  {svgNum:'032',wx:'陰時多雲短暫雨有霧'},
  {svgNum:'032',wx:'陰時多雲短暫雨晨霧'},
  {svgNum:'032',wx:'陰時多雲短暫陣雨有霧'},
  {svgNum:'032',wx:'陰時多雲短暫陣雨晨霧'},
  {svgNum:'032',wx:'陰陣雨有霧'},
  {svgNum:'032',wx:'陰短暫雨有霧'},
  {svgNum:'032',wx:'陰短暫雨晨霧'},
  {svgNum:'032',wx:'陰短暫陣雨有霧'},
  {svgNum:'032',wx:'陰短暫陣雨晨霧'},
  {svgNum:'033',wx:'多雲局部陣雨或雷雨'},
  {svgNum:'033',wx:'多雲局部短暫陣雨或雷雨'},
  {svgNum:'033',wx:'多雲局部短暫雷陣雨'},
  {svgNum:'033',wx:'多雲局部雷陣雨'},
  {svgNum:'034',wx:'多雲時陰局部陣雨或雷雨'},
  {svgNum:'034',wx:'多雲時陰局部短暫陣雨或雷雨'},
  {svgNum:'034',wx:'多雲時陰局部短暫雷陣雨'},
  {svgNum:'034',wx:'多雲時陰局部雷陣雨'},
  {svgNum:'034',wx:'晴午後陰局部陣雨或雷雨'},
  {svgNum:'034',wx:'晴午後陰局部短暫陣雨或雷雨'},
  {svgNum:'034',wx:'晴午後陰局部短暫雷陣雨'},
  {svgNum:'034',wx:'晴午後陰局部雷陣雨'},
  {svgNum:'034',wx:'陰局部陣雨或雷雨'},
  {svgNum:'034',wx:'陰局部短暫陣雨或雷雨'},
  {svgNum:'034',wx:'陰局部短暫雷陣雨'},
  {svgNum:'034',wx:'陰局部雷陣雨'},
  {svgNum:'034',wx:'陰時多雲局部陣雨或雷雨'},
  {svgNum:'034',wx:'陰時多雲局部短暫陣雨或雷雨'},
  {svgNum:'034',wx:'陰時多雲局部短暫雷陣雨'},
  {svgNum:'034',wx:'陰時多雲局部雷陣雨'},
  {svgNum:'035',wx:'多雲有陣雨或雷雨有霧'},
  {svgNum:'035',wx:'多雲有雷陣雨有霧'},
  {svgNum:'035',wx:'多雲有霧有陣雨或雷雨'},
  {svgNum:'035',wx:'多雲有霧有雷陣雨'},
  {svgNum:'035',wx:'多雲局部陣雨或雷雨有霧'},
  {svgNum:'035',wx:'多雲局部短暫陣雨或雷雨有霧'},
  {svgNum:'035',wx:'多雲局部短暫雷陣雨有霧'},
  {svgNum:'035',wx:'多雲局部雷陣雨有霧'},
  {svgNum:'035',wx:'多雲陣雨或雷雨有霧'},
  {svgNum:'035',wx:'多雲短暫陣雨或雷雨有霧'},
  {svgNum:'035',wx:'多雲短暫雷陣雨有霧'},
  {svgNum:'035',wx:'多雲雷陣雨有霧'},
  {svgNum:'035',wx:'多雲時晴短暫陣雨或雷雨有霧'},
  {svgNum:'036',wx:'多雲時陰有陣雨或雷雨有霧'},
  {svgNum:'036',wx:'多雲時陰有雷陣雨有霧'},
  {svgNum:'036',wx:'多雲時陰有霧有陣雨或雷雨'},
  {svgNum:'036',wx:'多雲時陰有霧有雷陣雨'},
  {svgNum:'036',wx:'多雲時陰局部陣雨或雷雨有霧'},
  {svgNum:'036',wx:'多雲時陰局部短暫陣雨或雷雨有霧'},
  {svgNum:'036',wx:'多雲時陰局部短暫雷陣雨有霧'},
  {svgNum:'036',wx:'多雲時陰局部雷陣雨有霧'},
  {svgNum:'036',wx:'多雲時陰陣雨或雷雨有霧'},
  {svgNum:'036',wx:'多雲時陰短暫陣雨或雷雨有霧'},
  {svgNum:'036',wx:'多雲時陰短暫雷陣雨有霧'},
  {svgNum:'036',wx:'多雲時陰雷陣雨有霧'},
  {svgNum:'036',wx:'陰局部陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰局部短暫陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰局部短暫雷陣雨有霧'},
  {svgNum:'036',wx:'陰局部雷陣雨有霧'},
  {svgNum:'036',wx:'陰時多雲有陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰時多雲有雷陣雨有霧'},
  {svgNum:'036',wx:'陰時多雲有霧有陣雨或雷雨'},
  {svgNum:'036',wx:'陰時多雲有霧有雷陣雨'},
  {svgNum:'036',wx:'陰時多雲局部陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰時多雲局部短暫陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰時多雲局部短暫雷陣雨有霧'},
  {svgNum:'036',wx:'陰時多雲局部雷陣雨有霧'},
  {svgNum:'036',wx:'陰時多雲陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰時多雲短暫陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰時多雲短暫雷陣雨有霧'},
  {svgNum:'036',wx:'陰時多雲雷陣雨有霧'},
  {svgNum:'036',wx:'陰短暫陣雨或雷雨有霧'},
  {svgNum:'036',wx:'陰短暫雷陣雨有霧'},
  {svgNum:'036',wx:'雷陣雨有霧'},
  {svgNum:'037',wx:'多雲局部雨或雪有霧'},
  {svgNum:'037',wx:'多雲時陰局部雨或雪有霧'},
  {svgNum:'037',wx:'陰時多雲局部雨或雪有霧'},
  {svgNum:'037',wx:'陰局部雨或雪有霧'},
  {svgNum:'037',wx:'短暫雨或雪有霧'},
  {svgNum:'037',wx:'有雨或雪有霧'},
  {svgNum:'038',wx:'短暫陣雨有霧'},
  {svgNum:'038',wx:'短暫陣雨晨霧'},
  {svgNum:'038',wx:'短暫雨有霧'},
  {svgNum:'038',wx:'短暫雨晨霧'},
  {svgNum:'039',wx:'有雨有霧'},
  {svgNum:'039',wx:'陣雨有霧'},
  {svgNum:'040',wx:'陰時多雲局部雨或雪有霧'},
  {svgNum:'041',wx:'短暫陣雨或雷雨有霧'},
  {svgNum:'041',wx:'陣雨或雷雨有霧'},
  {svgNum:'042',wx:'下雪'},
  {svgNum:'042',wx:'積冰'},
  {svgNum:'042',wx:'暴風雪'},
]


// WEBPACK FOOTER //
// ./src/components/beautiful-chat/Weather/weatherIconData.js